
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "16px",
    "height": "17px"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "fill-rule": "evenodd",
        "fill": "rgb(60, 152, 254)",
        "d": "M15.304,16.061 L0.694,16.061 C0.310,16.061 -0.001,15.736 -0.001,15.334 L-0.001,14.243 C-0.001,13.468 0.471,12.482 5.302,10.253 C6.120,9.875 5.908,8.442 5.913,8.425 C5.919,8.391 5.946,8.364 5.963,8.333 C4.966,7.326 4.307,5.669 4.307,4.061 C4.307,1.512 5.960,0.061 7.999,0.061 C10.038,0.061 11.692,1.512 11.692,4.061 C11.692,5.675 11.027,7.337 10.023,8.343 C10.044,8.370 10.074,8.396 10.086,8.425 C10.124,8.517 9.769,9.880 10.820,10.283 C15.612,12.124 15.999,13.568 15.999,14.243 L15.999,15.334 C15.999,15.736 15.688,16.061 15.304,16.061 Z"
      }
    }
  ]
})
    }
  